import axios from 'axios';
import { getToken, removeToken } from '@/lib/tokenStorage';

export interface ApiResponse<T> {
  success: boolean;
  response?: T;
}

const apiClient = axios.create({
  baseURL: __API_BASE__,
});

apiClient.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.token = token;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const hadToken = !!getToken();
      removeToken();
      // Редиректим только если токен был: иначе 401 на /login зациклит страницу.
      if (hadToken) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
